import { apiFetch, apiFetchWithMeta } from './client.js'

export type ProjectPackSummary = {
  readonly packSlug: string
  readonly packName: string
  readonly kind: string
  readonly activeVersion: string
  readonly stale: boolean
  readonly resolutionReason: string
}

export type PackVersionSummary = {
  readonly versionId: string
  readonly version: string
  readonly status: string
  readonly contentHash: string
  readonly createdAt: string
}

export type PackDetails = {
  readonly packSlug: string
  readonly packName: string
  readonly kind: string
  readonly scope: string
  readonly description: string
  readonly versions: readonly PackVersionSummary[]
  readonly tags: readonly string[]
}

export type KnowledgeSearchResult = {
  readonly source: 'kb' | 'pack'
  readonly id: string
  readonly packSlug?: string
  readonly packName?: string
  readonly packVersion?: string
  readonly title: string
  readonly preview: string
  readonly stale?: boolean
}

export function fetchProjectPacks(): Promise<{
  data: ProjectPackSummary[]
  meta?: { total?: number }
}> {
  return apiFetchWithMeta<ProjectPackSummary[]>('/api/v2/knowledge/packs')
}

export function fetchPackDetails(slug: string): Promise<PackDetails> {
  return apiFetch<PackDetails>(`/api/v2/knowledge/packs/${encodeURIComponent(slug)}`)
}

export function searchKnowledge(
  query: string,
): Promise<{ data: KnowledgeSearchResult[]; meta?: { total?: number } }> {
  return apiFetchWithMeta<KnowledgeSearchResult[]>('/api/v2/knowledge/search', {
    q: query,
    source: 'all',
    page_size: 8,
  })
}
